import "./styles/faq.css";
import { HiOutlinePlus } from "react-icons/hi";
import { HiOutlineMinusSm } from "react-icons/hi";
const FAQ = ({
  handleSelectFaq,
  title,
  answer,
  showContent

}) => {
  return (
    <section className="faq-section">
      <div className="container">
        <div className="faq-title" onClick={handleSelectFaq}>
          <h2>{title}</h2>
          <p>
            {showContent ? <HiOutlineMinusSm color="rgba(42, 42, 42, 1)"/> : (
              <HiOutlinePlus color="rgba(42, 42, 42, 1)"/>
            )}
          </p>
        </div>
        <div
          className="faq-content"
          style={{
            height: showContent ? "100px" : "",
          }}
        >
          <div className="faq-inner-content">
            <p>{answer}</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQ;
